import React from "react";
import styles from "./style.module.scss";
import DecorateImg from "@/assets/images/space/my-like-empty-img.png";

interface IEmptyContent {
  firstContent?: string;
  secondContent?: string;
}

const EmptyContent: React.FC<IEmptyContent> = ({ firstContent, secondContent }) => {
  return (
    <div className={styles["empty-content-wrapper"]}>
      <div className={styles["empty-img-wrapper"]}>
        <img src={DecorateImg} alt="" />
        <div className={styles["tip-text"]}>
          <p>{`${firstContent ? firstContent : "您还没有点赞过任何作品"}`}</p>
          <p>{`${secondContent ? secondContent : "可以在艺术展给您喜欢的作品点赞哦👍"}`}</p>
        </div>
        <div className={styles["describe"]}>
          一个人站在灰色沉闷的悬崖上，眺望着色彩缤纷的宇宙，云，星星，艺术家席德·米德、寺田克也、Atey
          Ghailan，Svetlin Velinov
        </div>
      </div>
    </div>
  );
};

export default EmptyContent;
